import { NotifierFactory } from "@shared/services/api/abstracts/notifiers/NotifierFactory";
import { toBase64 } from "@shared/utils/file-utils/utils";
import { getExceptionToastDescription } from "@shared/utils/errors/error-utils";
import { useState } from "react";
import { ImageUploadInputPropsType } from "./ImageUploadInput.props";
import { useCropper } from "./useCropper";

export function useImageUploadInput(props: ImageUploadInputPropsType) {
  const { minWidth, minHeight, handleErrorCodes, updateImage } = props;
  const [mimeType, setMimeType] = useState<string>("image/jpeg");
  const { updateIsCropping, finishCropping, isCropping, cropperRef } =
    useCropper({ ...props, mimeType });

  const notifier = NotifierFactory.createNotifier();
  const [currentFile, setCurrentFile] = useState<File>();

  const updateCurrentFile = (input: File | undefined) => {
    setCurrentFile(input);
  };

  const acceptedFileTypes = {
    "image/png": [".png"],
    "image/jpeg": [".jpeg", ".jpg"],
  };

  const onDrop = (fileList: Array<File>) => {
    const img = new Image();
    img.src = URL.createObjectURL(fileList[0]);

    img.onload = async () => {
      const { naturalHeight, naturalWidth } = img;

      if (naturalWidth < minWidth || naturalHeight < minHeight) {
        notifier.error(
          getExceptionToastDescription(handleErrorCodes["file-min-dimensions"])
        );
        return;
      }
      updateIsCropping(true);
      const imgSrc = await toBase64(fileList[0]);
      const mime = fileList[0].type;
      setMimeType(mime);
      updateImage(imgSrc.toString());
      updateCurrentFile(fileList[0]);
    };
  };

  const restartUpload = () => {
    updateImage(undefined);
    updateCurrentFile(undefined);
    updateIsCropping(false);
  };

  return {
    onDrop,
    updateCurrentFile,
    restartUpload,
    finishCropping,
    currentFile,
    acceptedFileTypes,
    isCropping,
    cropperRef,
  };
}
